import { createCrewLookupSelect } from './createCrewLookupSelect';

export const SignOffReasonSelect = createCrewLookupSelect('SignOffReasonSelect', 'signOffReasons');
export default SignOffReasonSelect;
